import React from 'react';
import ContactSection from '../components/sections/Contact';

function Contact() {
  return (
    <div className="animate-fade-in-up">
      <ContactSection />
    </div>
  );
}

export default Contact;
